import styled from "styled-components";
import { Column, Row } from 'components/Layout/Grid';
import { Button } from "components/Button";

export const ColumnContent = styled(Column)`
  button, select{
    width: 212px;
  } 

  @media screen and (max-width: 1060px) {
    button, select{
      width: 190px;
      margin: 0;
    }
  }  

  @media screen and (max-width: 1030px) {
    button, select{
      width: 160px;
      margin: 0;
    }
  }  

  @media screen and (max-width: 750px) {    
    button, select{
      margin-right: 10px;
    }
  }
`;

export const FirstRow = styled(Row)`
  margin-bottom: 10px;
  justify-content: right;

  .sendBtn{
    min-height: 40px;
    padding: 0;
  }
  
  @media screen and (max-width: 1000px) {
    flex-direction: column;
    align-items: flex-end;

    .actBtn{
      margin-right: 0;
    }

    .sendBtn{
      margin-top: 10px;
      justify-items: right;
    }
  }  

  @media screen and (max-width: 750px) {
    margin: 0;
    flex-direction: row;

    .sendBtn{
      margin: 0;
    }
  }
`;

export const SecondRow = styled(Row)`
  justify-content: right;

  @media screen and (max-width: 1000px) {
    width: 200px;
  }  

  @media screen and (max-width: 750px) {
    flex-direction: row-reverse;
    width: auto;
    justify-content: left;
    margin-top: 10px;
  }
`;

export const SelectColumn = styled(Column).attrs({className: "justify-end outline"})``;

export const CustomButton = styled(Button)<{ isDisable: boolean }>`
  background-color: ${(props) => props.isDisable ? "#bebebe" : "#0E4C54"};  
`;